import React from 'react';
import Quotation from "../components/quotation/Quotation";

const QuotationPage = () => {
    return (
        <div>
            <Quotation />
        </div>
    );
};

export default QuotationPage;
